import { ImportedData, ImportedDataType } from 'lib/imported-data/ImportedData.types';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

/** Mirrors the fragment defined in the integrated GraphQL query. */
export interface PageItem {
  name?: string;
  navigationTitle?: {
    value?: string;
  };
  url?: {
    path?: string;
  };
  excludeFromBreadcrumb?: {
    boolValue?: boolean;
  };
  isSiteRoot?: {
    boolValue?: boolean;
  };
}

/** See?: integrated GraphQL query on rendering. */
export interface QueryResult {
  currentPage?: PageItem & {
    ancestors?: Array<PageItem>;
  };
}

export interface BreadcrumbModel {
  ancestors?: Array<PageItem>;
  currentPage?: PageItem;
}

export interface N05BreadcrumbFields {
  data?: QueryResult;
}

export interface N05BreadcrumbsServerSideProps {
  importedData?: ImportedData;
  sparkleType?: ImportedDataType;
}

export type N05BreadcrumbParams = DynamicPlaceholderParams &
  AnchorTargetParams &
  TranslationOptionsParams;

export type N05BreadcrumbProps = RenderingProps<N05BreadcrumbFields, N05BreadcrumbParams> &
  N05BreadcrumbsServerSideProps;
